export const ColorSpace = {
  RGB: 0,
  HSV: 1,
  LAB: 2,
  DIVERGING: 3,
};

export const Scale = {
  LINEAR: 0,
  LOG10: 1,
};

export default {
  ColorSpace,
  Scale,
};
